import React from 'react';

const RejectedTimeSheets = () => {
    return (
        <div className="view-rejected-sheets-container">
            <div className="content-section">
                {/* Shorter Question Tag */}
                <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    How to fix a rejected timesheet?
                </h3>

                {/* Explanation about Rejected Timesheets */}
                <p className="description">
                    This section helps employees and managers track all timesheets that have been "rejected" during the approval process. 
                    A timesheet can be rejected by either the "Approval Manager" or the "Super Admin", and it will not proceed further unless the necessary corrections are made.
                </p>
                
                <p className="description">
                    Employees must review the comments provided along with the rejected timesheet, make necessary corrections, and "resubmit the timesheet" for approval. 
                    Keeping track of rejected timesheets helps ensure timely corrections and avoid payment delays.
                </p>

                {/* Step Guide */}
                <h4 className="section-heading">Steps to Check and Resubmit a Rejected Timesheet:</h4>
                <ul className="step-guide">
                    <li><strong>Step 1:</strong> Log in to your dashboard.</li>
                    <li><strong>Step 2:</strong> Navigate to the "sidebar menu" and select "Rejected Sheets".</li>
                    <li><strong>Step 3:</strong> Review the rejected timesheet details and check for any "comments" from the approval manager.</li>
                    <li><strong>Step 4:</strong> Make the necessary corrections and "resubmit" the timesheet.</li>
                </ul>

                {/* Image Representation */}
                <img
                    className="placeholder-image image_gatnix_support"
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737375724/Rejected_sheets-3_l7mejj.png"
                    alt="Rejected Timesheets"
                    style={{ width: "75%", height: "auto", maxWidth: "700px", margin: "20px 0" }} 
                />

                {/* Tip Section */}
                <h4 className="section-heading">Tip:</h4>
                <p className="tip-text">
                    If a timesheet has been rejected, you can "add a comment" to the employee stating: <br />
                    <strong>"Please resubmit your timesheet after making the required corrections."</strong>
                </p>

                {/* Note Section */}
                <h4 className="section-heading">Note:</h4>
                <ul className="note-points">
                    <li>You can download the "rejected timesheets" from this section for further review.</li>
                </ul>
            </div>
        </div>
    );
};

export default RejectedTimeSheets;
